import axios, { AxiosInstance } from 'axios';
import { UserApi } from './UserApi';
import { forEach } from 'lodash-es';

export default class ApiProvider {
    public static getUserClients(siteTags: string[]): UserApi[] {
        let apis: UserApi[] = [];

        forEach(siteTags, (siteTag) => {
            apis.push(new UserApi(siteTag, this.getAxios()));
        });

        return apis;
    }

    private static getAxios(): AxiosInstance {
        const ax = axios.create();
        ax.interceptors.request.use(req => {
            req.url += req.url.indexOf('?') > -1
                ? '&'
                : '?';

            req.url += '_ts=' + Math.random();
            return req;
        })
        return ax;
    }
}